export default __webpack_public_path__ + "static/media/checkbox.4d8f37d8.svg";